import {
  ACTION_VARIANTS,
  Button,
  Icon,
  ICON_NAMES,
} from '@reverse-hr/design-system';
import { Trans, useTranslation } from 'react-i18next';
import { useStoreActions } from 'easy-peasy';
import { showcaseTableSelector } from '@app/store/selectors/showcase-table';

const RowDescriptionCell = props => {
  const { name, hasVisibilityAction } = props;
  const { hideRow } = useStoreActions(showcaseTableSelector);

  const { t } = useTranslation();

  const renderHideAction = () =>
    hasVisibilityAction && (
      <div className="c-app-showcase__toggles">
        <Button
          className="c-app-showcase__hide"
          leftIcon={ICON_NAMES.HIDE}
          onClick={() => {
            hideRow(name);
          }}
          variant={ACTION_VARIANTS.GHOST}
        />
      </div>
    );

  const renderDragIcon = () =>
    hasVisibilityAction && (
      <div className="c-app-showcase__toggles">
        <div className="c-app-showcase__drag">
          <Icon name={ICON_NAMES.GRID_VERTICAL} size={20} />
        </div>
      </div>
    );

  return (
    <td className="c-app-showcase__label">
      {renderDragIcon()}
      <strong>
        <Trans i18nKey={`showcase.tableRows.${name}`}>
          1<br />2<br />3
        </Trans>
      </strong>
      {renderHideAction()}
    </td>
  );
};

export default RowDescriptionCell;
